import React from 'react';
import * as Styles from '../Alerts.styles';
import { Checkbox, Button } from 'gatorcomponents';

const AlertCard = ({
  item,
  handleSelectAlerts,
  isChecked,
  handleAlertAction,
}) => {
  const {
    title, description, actionLabel, severity, Icon,
  } = item;

  if (!severity) {
    return null;
  }

  return (
    <Styles.AlertCardWrapper key={item.type.slug} data-testid={`alert-card-${item.type.slug}`}>
      <Styles.MobileLayout>
        <Styles.MobileFirstRow>
          <Styles.CheckboxLabel onClick={() => handleSelectAlerts(item.type.slug)} htmlFor="check-alert-mobile" data-testid={`checkbox-alert-mobile-${item.type.slug}`}>
            <Checkbox checked={isChecked} id="check-alert-mobile" />
          </Styles.CheckboxLabel>

          <Styles.AlertCardIconCircle>
            {Icon && <Icon color="primaryMedium" size="md" />}
            <Styles.PriorityDot $severity={severity} />
          </Styles.AlertCardIconCircle>

          <Styles.AlertCardTitle>{title}</Styles.AlertCardTitle>
        </Styles.MobileFirstRow>

        <Styles.MobileSecondRow>
          <Styles.AlertCardDescription>
            {description}
          </Styles.AlertCardDescription>
        </Styles.MobileSecondRow>

        <Button
          label={actionLabel}
          onClick={handleAlertAction}
          variant="secondary"
          size="medium2"
          width="full"
          testId={`action-button-${item.type.slug}`}
        />
      </Styles.MobileLayout>

      <Styles.DesktopLayout>
        <Styles.AlertCardContent>
          <Styles.CheckboxLabel onClick={() => handleSelectAlerts(item.type.slug)} htmlFor="check-alert-desktop">
            <Checkbox checked={isChecked} id="check-alert-desktop" />
          </Styles.CheckboxLabel>
          <Styles.AlertCardInfo>
            <Styles.AlertCardIconCircle>
              {Icon && <Icon color="primaryMedium" size="md" />}
              <Styles.PriorityDot $severity={severity} />
            </Styles.AlertCardIconCircle>

            <Styles.AlertCardText>
              <Styles.AlertCardTitle>{title}</Styles.AlertCardTitle>
              <Styles.AlertCardDescription>
                {description}
              </Styles.AlertCardDescription>
            </Styles.AlertCardText>
          </Styles.AlertCardInfo>
        </Styles.AlertCardContent>

        <Button
          label={actionLabel}
          onClick={handleAlertAction}
          variant="tertiary"
          size="medium2"
          testId={`action-button-${item.type.slug}`}
        />
      </Styles.DesktopLayout>
    </Styles.AlertCardWrapper>
  );
};
export default AlertCard;
